import React, { useState,useEffect } from "react";
import { Link, useNavigate, useParams } from 'react-router-dom'
import axios from "axios"
import RichTextEditor from "@mantine/rte"
import { DatePicker, Space } from "antd"
import { Exhibitionadd, api } from "../../apis/urls"
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from "yup"
import { Controller, useForm } from "react-hook-form"
import moment from "moment"

const EditExhibition = () => {

    const [description, setDescription] = useState('')
    const [date, setDate] = useState('')
    const [year, setYear] = useState('')

    // get full year

    const getFullYear = () => {
        let year = new Date().getFullYear();
        let years = [];
        for (let i = 0; i < 10; i++) {
            years.push(year + i);
        }
        return years;
    }

    const validationSchema = yup.object().shape({
        name: yup.string().required('Exhibition Name is required'),
        year: yup.string().required('Year is required'),
        registration_date: yup.string().required('Registration Date is required'),
        agreement: yup.string().required('Agreement is required'),
    });

    const { id } = useParams();

    let navigate = useNavigate()
    const RoutToList = () =>{
        navigate("/elecostlist")     
    }

    const onEditForm = (data) => {

            let token = "Bearer "+localStorage.getItem('token');
            
            const instance = axios.create({

                baseURL: Exhibitionadd,

                timeout: 1000000,

                headers: {'authorization': token}

            });
            
            instance.post('',data).then((response) =>{
                
                
                navigate("/exhibition")
            
            }).catch((error) =>{
                
                console.log('error',error.message)

            });
        
    }

    const { handleSubmit, register, formState:{errors}, setValue, control, getValues } = useForm({
        resolver: yupResolver(validationSchema)
    });

    const onSubmit = (data) => {
        const dataValue = {
            name :data.name,
            description :data.description,
            image:fileUp,
            year:data.year,
            registration_date:data.registration_date,
            agreement:data.agreement
        }

        onEditForm(dataValue);
    }

    const [fileUp, setFileUp] = useState('');
    const [fileSelect, setFileSelect] = useState('');


    const changeHandler =(event)=>{

        setFileSelect(event.name)

        let token = "Bearer "+localStorage.getItem('token');

        const data = new FormData();

        data.append('file', event)

        const instance = axios.create({
            baseURL: api+ 'workshopImage/upload',
            timeout: 1000000,
            headers: {'authorization': token, "Content-Type":  "multipart/form-data"},
        });

        instance.post('', data).then((response) =>{
            setFileUp(response.data.Location)
        }).catch((error) =>{     
            console.log('error',error.message)  
        });

    }

    const [pdf, setPdf] = useState('');

    const changeHandlerAgreement =(event)=>{

        let token = "Bearer "+localStorage.getItem('token');

        const data = new FormData();

        data.append('file', event)

        const instance = axios.create({
            baseURL: api+ 'workshopImage/upload',
            timeout: 1000000,
            headers: {'authorization': token, "Content-Type":  "multipart/form-data"},
        });

        instance.post('', data).then((response) =>{
            setValue('agreement', response?.data?.Location)
            setPdf(response?.data?.Location)
        }).catch((error) =>{     
            console.log('error',error.message)  
        });

    }

    return(
        <div className="wrapper">
            <aside className="right-side ">
                <div className="content-area">
                    <div className="page-title-wrpr">
                        <div className="page-title-left-column">
                            
                            <h2 className="page-title">Add Exhibition</h2>
                        </div>                    
                    </div>


                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                            <li className="breadcrumb-item"><Link to="/exhibition">Exhibitor</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">Add Exhibition</li>
                        </ol>
                    </nav>


                    <form onSubmit={handleSubmit(onSubmit)} className="needs-validation" noValidate>
                        <div className="form-wrpr">
                            <div className="card formcard medium">
                                <div className="card-body">
                                    <div className="form-group">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <label className="degreehead">Exhibition Name <span style={{color: "red"}}>*</span></label>
                                                <input name="name" {...register('name')} type="text" className="form-control bg-dark dark-theme showtext" id="name"></input>
                                                <p className="error-text message">{errors?.name?.message}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <label className="degreehead">Description</label>
                                                <Controller
                                                    name="description"
                                                    control={control}
                                                    defaultValue={`${description}`}
                                                    render={({ field }) => <RichTextEditor {...field} />}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <label className="degreehead">Year<span style={{color: "red"}}>*</span></label>
                                                <select {...register('year')} name="year" className="form-control bg-dark dark-theme showtext" id="status-selector" >
                                                    <option value="">Select Year</option>
                                                    {getFullYear().map
                                                        (year => (
                                                            <option key={year} value={year}>
                                                                {year}
                                                            </option>
                                                        ))
                                                    }
                                                </select>
                                                <p className="error-text message">{errors?.year?.message}</p>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-exhibition-group date-exhibition">
                                                    <label className="degreehead">Registration Deadline<span style={{color: "red"}}>*</span></label>
                                                    <Controller
                                                        name="registration_date"
                                                        control={control}
                                                        render={({ field: { onChange } }) => (
                                                            <DatePicker
                                                                onChange={(date) => {
                                                                    const d = new Date(date).toLocaleDateString('fr-FR');
                                                                    console.log(date ? moment(date).format('YYYY-MM-DD'):'')   
                                                                    onChange(date && moment(date).format('YYYY-MM-DD'));
                                                                }}
                                                                className="form-control showtext"
                                                            />
                                                        )}
                                                    />
                                                    <p className="error-text message">{errors?.registration_date?.message}</p>
                                                </div>
                                            </div>
                                        </div>
                                   </div>                               

                                    <div className="form-group">
                                        <div className="row">
                                            <div className="col-md-12">	
                                                <label className="degreehead">Agreement<span style={{color: "red"}}>*</span></label>	
                                                <div>
                                                    <div class='file-input' style={{background:"#e6e8eaab", width:'100%'}}>
                                                        <input type='file' onChange={(event)=>{changeHandlerAgreement(event.target.files[0]);}}  />	
                                                        <span span class='button' style={{background:'dodgerblue', color:'#fff', fontWeight:'500', fontSize:'12px'}}>Choose</span>
                                                        <span class='labels' style={{color:pdf?'dodgerblue':'gray', fontWeight:'500', fontSize:'12px', paddingLeft:pdf?'10px':null }} data-js-label>{!pdf?"No file selected":pdf}</span>
                                                    </div>
                                                    <p className="error-text message">{errors?.agreement?.message}</p>
                                                </div>
                                            </div>
                                        </div>
							        </div>

                                    <div className="form-group">
                                        <div className="row">
                                            <div className="col-md-12">	
                                                <label  className="degreehead">You may upload a representative image of the exhibition</label>	
                                                <div>
                                                    <div class='file-input' style={{background:"#e6e8eaab", width:'100%'}}>
                                                    <input type='file' onChange={(event)=>{changeHandler(event.target.files[0]);}}  />	
                                                    {!fileUp?
                                                        <span span class='button' style={{background:'dodgerblue', color:'#fff', fontWeight:'500', fontSize:'12px'}}>Choose</span>:
                                                        <img src={fileUp} width="5%" />
                                                    }
                                                    <span class='labels' style={{color:fileUp?'dodgerblue':'gray', fontWeight:'500', fontSize:'12px', paddingLeft:fileUp?'10px':null }} data-js-label>{!fileSelect?"No file selected":fileSelect}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
							        </div>

                                    <h6 style={{color: "red"}}>* Required Fields</h6>
                                    <div className="form-group text-right">
                                        {/* <button className="btn btn-primary btn-gisa cancelbtn" onClick={RoutToList}>Cancel</button> */}
                                        <button type="submit" className="btn btn-primary btn-gisa">Create</button>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </form>






                </div>
            </aside>
        </div>

    )
}

export default EditExhibition;
